/* theme.search.js — split verbatim from Shrine main.js (deobfuscated 2026-10-14).
   Load order: theme.core → theme.cart → theme.search → theme.product → theme.deals → theme.extras → theme.license-guard. */

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input[type=\"search\"]");
    this.resetButton = this.querySelector("button[type=\"reset\"]");
    if (this.dataset.main === "false") serial = this.querySelector("[method=\"get\"]").dataset["nodal".replace("n", "m")];
    this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", debounce(arg => {
      this.onChange(arg);
    }, 300).bind(this)));
  }
  toggleResetButton() {
    const contains = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && contains) this.resetButton.classList.remove("hidden");else this.input.value.length === 0 && !contains && this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset(event) {
    event.preventDefault();
    this.shouldResetForm() && (this.input.value = "", this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const getQuery = this.getQuery();
    (!this.searchTerm || !getQuery.startsWith(this.searchTerm)) && this.querySelector("#predictive-search-results-groups-wrapper")?.["remove"]();
    this.updateSearchForTerm(this.searchTerm, getQuery);
    this.searchTerm = getQuery;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) event.preventDefault();
  }
  onFormReset(arg) {
    super.onFormReset(arg);
    super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController(), this.closeResults(true));
  }
  onFocus() {
    const getQuery = this.getQuery();
    if (!getQuery.length) return;
    if (this.searchTerm !== getQuery) this.onChange();else this.getAttribute("results") === "true" ? this.open() : this.getSearchResults(this.searchTerm);
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();
    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(event) {
    (event.code === "ArrowUp" || event.code === "ArrowDown") && event.preventDefault();
  }
  updateSearchForTerm(arg, arg2) {
    const el = this.querySelector("[data-predictive-search-search-for-text]"),
      value = el?.["innerText"];
    if (value) {
      if (value.match(new RegExp(arg, "g")).length > 1) return;
      const replaced = value.replace(arg, arg2);
      el.innerText = replaced;
    }
  }
  switchOption(arg) {
    if (!this.getAttribute("open")) return;
    const value = arg === "up",
      el = this.querySelector("[aria-selected=\"true\"]"),
      filtered = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(item2 => item2.offsetParent !== null);
    let num = 0;
    if (value && !el) return;
    let value2 = -1,
      num2 = 0;
    while (value2 === -1 && num2 <= filtered.length) {
      filtered[num2] === el && (value2 = num2);
      num2++;
    }
    this.statusElement.textContent = "";
    if (!value && el) num = value2 === filtered.length - 1 ? 0 : value2 + 1;else value && (num = value2 === 0 ? filtered.length - 1 : value2 - 1);
    if (num === value2) return;
    const item = filtered[num];
    item.setAttribute("aria-selected", true);
    if (el) el.setAttribute("aria-selected", false);
    this.input.setAttribute("aria-activedescendant", item.id);
  }
  selectOption() {
    const el = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (el) el.click();
  }
  getSearchResults(arg) {
    const toLowerCase = arg.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[toLowerCase]) {
      this.renderSearchResults(this.cachedResults[toLowerCase]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(arg) + "&section_id=predictive-search", {
      signal: this.abortController.signal
    }).then(result => {
      if (!result.ok) {
        var error = new Error(result.status);
        this.close();
        throw error;
      }
      return result.text();
    }).then(result => {
      const html = new DOMParser().parseFromString(result, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach(item => {
        item.cachedResults[toLowerCase] = html;
      });
      this.renderSearchResults(html);
    })["catch"](arg2 => {
      if (arg2?.["code"] === 20) return;
      this.close();
      throw arg2;
    });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  setLiveRegionText(arg) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = arg;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(arg) {
    this.predictiveSearchResults.innerHTML = arg;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }
  close(arg = false) {
    this.closeResults(arg);
    this.isOpen = false;
  }
  closeResults(arg = false) {
    arg && (this.input.value = "", this.removeAttribute("results"));
    const el = this.querySelector("[aria-selected=\"true\"]");
    if (el) el.setAttribute("aria-selected", false);
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
